function importAll(r) {
	const gallery = [];
	r.keys().forEach(item => {
		gallery.push({
			original: `${r(item)}`,
			thumbnail: `${r(item)}`,
		});
	});
	return gallery;
}
const gallery0 = importAll(
	require.context('../assets/images/gallery0', false, /\.(png|jpe?g|svg)$/)
);
// const gallery1 = importAll(
// 	require.context('../assets/images/gallery1', false, /\.(png|jpe?g|svg)$/)
// ); Add gallery1 to GalleryData array
// const gallery2 = importAll(
// 	require.context('../assets/images/gallery2', false, /\.(png|jpe?g|svg)$/)
// ); Add gallery2 to GalleryData array

const GalleryData = [gallery0];

export default GalleryData;
